import { render, staticRenderFns } from "./EmployeeGroupTable.vue?vue&type=template&id=395ef892"
import script from "./EmployeeGroupTable.vue?vue&type=script&lang=js"
export * from "./EmployeeGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports